import { Amplify } from "aws-amplify";
import { config } from "./config";

// This module configures Amplify as a side effect.
// Import it before any module that uses @aws-amplify/auth.
const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: config.cognito.userPoolId,
      userPoolClientId: config.cognito.clientId,
    },
  },
};

console.log("[SCD] Configuring Amplify with:", JSON.stringify(amplifyConfig));
Amplify.configure(amplifyConfig);
console.log("[SCD] Amplify configured. getConfig:", JSON.stringify(Amplify.getConfig()));
